module.exports = __webpack_public_path__ + "static/media/finalStep.723866bf.svg";